<template>
    <div class="pagenav" :class="parentClass">
        <div
            v-if="curPage > 1"
            @click.prevent="changePage(curPage - 1)"
            class="pagenav__btn pagenav__prev"
        >
            <svg class="pagenav__svg" width="20" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M16.5858 9.00006L10.2929 2.70718L11.7071 1.29297L20.4142 10.0001L11.7071 18.7072L10.2929 17.293L16.5858 11.0001L2 11.0001V9.00006L16.5858 9.00006Z" fill="black"/>
            </svg>
        </div>
        <div
            v-if="showFirstPage"
            @click.prevent="changePage(1)"
            class="pagenav__num g-text__p g_semibold"
        >1</div>
        <div
            v-if="showFirstPage"
            class="pagenav__num g-text__p g_semibold _disabled"
        >...</div>
        <div
            v-for="num in numList"
            :key="`pagenav-${num}`"
            @click.prevent="changePage(num)"
            :class="{_cur: num === curPage}"
            class="pagenav__num g-text__p g_semibold"
        >{{ num }}</div>
        <div
            v-if="showLastPage"
            class="pagenav__num g-text__p g_semibold _disabled"
        >...</div>
        <div
            v-if="showLastPage"
            @click.prevent="changePage(allPages)"
            class="pagenav__num g-text__p g_semibold"
        >{{ allPages }}</div>
        <div
            v-if="curPage < allPages"
            @click.prevent="changePage(curPage + 1)"
            class="pagenav__btn pagenav__next"
        >
            <svg class="pagenav__svg" width="20" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M16.5858 9.00006L10.2929 2.70718L11.7071 1.29297L20.4142 10.0001L11.7071 18.7072L10.2929 17.293L16.5858 11.0001L2 11.0001V9.00006L16.5858 9.00006Z" fill="black"/>
            </svg>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PageNav',
    props: {
        parentClass: {
            type: String,
            default: ''
        },
        totalPages: {
            type: Number,
            default: 1
        }
    },
    data () {
        return {
            curPage: 1,
            allPages: 2,
            showFirstPage: false,
            showLastPage: false,
        };
    },
    computed: {
        numList() {
            const isNotCloseToStart = this.curPage > 4;
            const isNotCloseToEnd = (this.curPage + 3) < this.allPages;

            if (this.allPages > 6) {
                this.showFirstPage = isNotCloseToStart;
                this.showLastPage = isNotCloseToEnd;

                if (!isNotCloseToStart) {
                    return this.collectMiddleBreadCrumbs(1, 5);
                } else if (!isNotCloseToEnd) {
                    return this.collectMiddleBreadCrumbs(this.allPages - 4, this.allPages);
                } else {
                    return this.collectMiddleBreadCrumbs(this.curPage - 2, this.curPage + 2);
                }
            } else {
                return this.collectMiddleBreadCrumbs(1, this.allPages);
            }
        }
    },
    created() {
        this.allPages = this.totalPages;
    },
    methods: {
        changePage(num) {
            this.curPage = num;
            this.$emit('changePage', num);
        },
        collectMiddleBreadCrumbs(start, end) {
            let result = [];

            for (let i = start; i <= end; i++) {
                result.push(i);
            }

            return result;
        }
    }
};
</script>
